import React from "react";
import TextField from "@mui/material/TextField";
import {Controller, useFormContext} from "react-hook-form";
import {styled} from "@mui/material/styles";
import {SxProps, Theme} from "@mui/material/styles";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import ErrorsList from "shared/ui/ErrorsList";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import AutocompleteAPI, {AutocompleteTextFieldStyled, PaperStyled} from "./AutocompleteAPI";
import {AxiosResponse} from "axios";
import {IOptions} from "features/users/api/teachers";
import InputAdornment from "@mui/material/InputAdornment";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import IconButton from "@mui/material/IconButton";
import AutocompleteAPIField from "./AutocompleteAPIField";

export const TextFieldStyled = styled(TextField)(({theme}) => ({
    margin: 0,
    borderRadius: 15,
    "& label": {
        color: theme.palette.text.secondary,
        paddingLeft: 12,
        lineHeight: "1.2em",
    },
    "& label.MuiInputLabel-shrink": {
        display: "none",
    },
    "& legend": {
        display: "none",
    },
    "& .MuiInputBase-input, & .MuiInputBase-input:focus, MuiInputBase-input:-webkit-autofill": {
        borderRadius: 15,
        backgroundColor: theme.palette.secondary.contrastText,
        padding: "14px 14px 14px 23px",
        color: theme.palette.text.secondary,
    },
    "& .MuiMenu-list": {
        backgroundColor: "#fff",
    },
    "& .Mui-error": {
        "& .MuiInputBase-input": {
            border: "1px solid #9D0000",
        },
    },
    "& .MuiOutlinedInput-root": {
        borderRadius: 15,
        "& fieldset": {
            border: "none",
        },
    },
    "&.dark": {
        "& label": {
            color: theme.palette.text.secondary,
        },
        "& .MuiInputBase-input": {
            borderRadius: 15,
            backgroundColor: theme.palette.secondary.contrastText,
            padding: "14px 14px 14px 23px",
            color: theme.palette.text.secondary,
        },
    },
    "& .MuiSelect-iconOutlined": {
        color: theme.palette.primary.light,
    },
    "& .MuiInputBase-multiline": {
        padding: 0,
    },
}));

export const IconTextFieldStyled = styled(TextField)(({theme}) => ({
    margin: 0,
    backgroundColor: theme.palette.secondary.contrastText,
    position: "relative",
    borderRadius: 15,
    "& label": {
        color: theme.palette.text.secondary,
        paddingLeft: 12,
        lineHeight: "1.2em",
    },
    "& label.MuiInputLabel-shrink": {
        display: "none",
    },
    "& legend": {
        display: "none",
    },
    "& .MuiInputBase-input, & .MuiInputBase-input:focus": {
        color: theme.palette.text.secondary,
        padding: "14px 14px 14px 23px",
        // padding: useMediaQuery(theme.breakpoints.up("sm")) ? "14px 14px 14px 23px" : "8.5px 14px 8.5px 23px",
    },
    "& .MuiSelect-iconOutlined": {
        color: theme.palette.primary.light,
    },
    "& .Mui-error": {
        "& .MuiInputBase-input": {
            border: "1px solid #9D0000",
            borderRadius: 15,
        },
    },
    "& .MuiOutlinedInput-root": {
        borderRadius: 15,
        "& fieldset": {
            border: "none",
            borderRadius: 15,
            backgroundColor: "#fff",
            zIndex: -1,
            top: 0,
        },
    },
    "&.dark": {
        "& label": {
            color: theme.palette.text.secondary,
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                border: "none",
                borderRadius: 15,
                backgroundColor: theme.palette.secondary.contrastText,
                zIndex: -1,
                top: 0,
            },
            "& .MuiInputBase-input": {
                color: theme.palette.text.secondary,
            },
        },
    },
}));

export const IconTextFieldSmallStyled = styled(TextField)(({theme}) => ({
    margin: 0,
    backgroundColor: theme.palette.secondary.contrastText,
    position: "relative",
    borderRadius: 15,
    "& label": {
        color: theme.palette.text.secondary,
        // paddingLeft: 12,
        lineHeight: "1.2em",
    },
    "& label.MuiInputLabel-shrink": {
        display: "none",
    },
    "& legend": {
        display: "none",
    },
    "& .MuiInputBase-input, & .MuiInputBase-input:focus": {
        color: theme.palette.text.secondary,
        // padding: "14px 14px 14px 23px",

        // padding: useMediaQuery(theme.breakpoints.up("sm")) ? "14px 14px 14px 23px" : "8.5px 14px 8.5px 23px",
    },
    "& .MuiSelect-iconOutlined": {
        color: theme.palette.primary.light,
    },
    "& .Mui-error": {
        "& .MuiInputBase-input": {
            border: "1px solid #9D0000",
            borderRadius: 15,
        },
    },
    "& .MuiSelect-icon": {
        right: "18px",
    },
    "& .MuiOutlinedInput-root": {
        borderRadius: 15,
        "& fieldset": {
            border: "none",
            borderRadius: 15,
            backgroundColor: "#fff",
            zIndex: -1,
            top: 0,
        },
    },
    "&.dark": {
        "& label": {
            color: theme.palette.text.secondary,
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                border: "none",
                borderRadius: 15,
                backgroundColor: theme.palette.secondary.contrastText,
                zIndex: -1,
                top: 0,
            },
            "& .MuiInputBase-input": {
                color: theme.palette.text.secondary,
            },
        },
    },
}));

export const IconTextFieldBgStyled = styled(TextField)(({theme}) => ({
    margin: 0,
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    borderRadius: 15,
    "& label": {
        color: theme.palette.text.secondary,
        paddingLeft: 12,
        lineHeight: "1em",
    },
    "& label.MuiInputLabel-shrink": {
        display: "none",
    },
    "& legend": {
        display: "none",
    },
    "& .MuiInputBase-input, & .MuiInputBase-input:focus": {
        color: theme.palette.text.secondary,
        padding: "4px 23px",

        // padding: useMediaQuery(theme.breakpoints.up("sm")) ? "14px 14px 14px 23px" : "8.5px 14px 8.5px 23px",
    },
    "& .MuiSelect-iconOutlined": {
        color: theme.palette.primary.light,
    },
    "& .Mui-error": {
        "& .MuiInputBase-input": {
            border: "1px solid #9D0000",
            borderRadius: 15,
        },
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: "none",
            borderRadius: 15,
            backgroundColor: "#fff",
            zIndex: -1,
            top: 0,
        },
    },
    "&.dark": {
        "& label": {
            color: theme.palette.text.secondary,
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                border: "none",
                borderRadius: 15,
                backgroundColor: theme.palette.secondary.contrastText,
                zIndex: -1,
                top: 0,
            },
            "& .MuiInputBase-input": {
                color: theme.palette.text.secondary,
                padding: "4px",
            },
        },
    },
}));

interface Option {
    value: string | number;
    label: string;

    [key: string]: any;
}

interface Props {
    name: string;
    type: string;
    value?: string | number;
    valueAutocomplete?: object | null;
    valueAutocompleteField?: object | undefined;
    defaultValue?: string | number | any[] | null;
    AutocompleteFieldDefaultValue?: string | number | any[] | undefined;
    label?: string;
    autoComplete?: string;
    autoFocus?: boolean;
    errorMessage?: string | undefined;
    error?: boolean;
    className?: string;
    options?: Option[];
    multiple?: boolean;
    onChange?: (e: any, value?: any) => void;
    onChangeAutocomplete?: (event: any, value: any) => void;
    onInputChange?: (e: any) => void;
    optionsAPI?: (options: IOptions) => Promise<AxiosResponse<any, any>>;
    filterOptions?: any;
    loading?: boolean;
    onClick?: () => void;
    controlled?: boolean;
    inputProps?: object;
    disableClearable?: boolean;
    disabled?: boolean;
    limitTags?: number;
    rows?: string | number | undefined;
    sxExtra?: SxProps<Theme>;
}

const FormField = ({
                       name,
                       type = "text",
                       value = "",
                       valueAutocomplete = null,
                       AutocompleteFieldDefaultValue = undefined,
                       defaultValue,
                       label,
                       autoComplete = "",
                       autoFocus = false,
                       errorMessage = "",
                       error = false,
                       className = "",
                       options = [],
                       multiple = false,
                       onChange = (e: any) => {},
                       onChangeAutocomplete,
                       onInputChange,
                       optionsAPI,
                       filterOptions,
                       loading,
                       onClick,
                       controlled = false,
                       inputProps,
                       disableClearable = false,
                       disabled = false,
                       limitTags = -1,
                       rows = undefined,
                       sxExtra = {},
                   }: Props) => {
    const methods = useFormContext();

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <Box width="100%">
            <>
                {(type === "text" || type === "password" || type === "hidden" || type === "number") && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <TextFieldStyled
                                {...field}
                                id={field.name}
                                error={error}
                                fullWidth
                                margin="normal"
                                label={label}
                                autoComplete={autoComplete}
                                autoFocus={autoFocus}
                                type={type}
                                className={className}
                                InputProps={{inputProps: inputProps}}
                            />
                        )}
                    />
                )}
                {(type === "textarea") && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <TextFieldStyled
                                id={field.name}
                                error={error}
                                fullWidth
                                margin="normal"
                                label={label}
                                autoComplete={autoComplete}
                                autoFocus={autoFocus}
                                type={type}
                                multiline
                                rows={rows}
                                {...field}
                                className={className}
                                InputProps={{inputProps: inputProps}}
                            />
                        )}
                    />
                )}
                {type === "controlled-number" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <TextFieldStyled
                                {...field}
                                id={field.name}
                                error={error}
                                fullWidth
                                margin="normal"
                                label={label}
                                autoFocus={autoFocus}
                                value={value || ""}
                                onChange={(e) => {
                                    onChange(e);
                                    methods.clearErrors("expire");
                                }
                                }
                                type="number"
                                className={className}
                                InputProps={{inputProps: inputProps}}
                            />
                        )}
                    />
                )}
                {type === "text-small" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <IconTextFieldSmallStyled
                                {...field}
                                id={field.name}
                                error={error}
                                size="small"
                                fullWidth
                                margin="normal"
                                label={label}
                                autoComplete={autoComplete}
                                autoFocus={autoFocus}
                                type="text"
                                sx={sxExtra}
                                className={className}
                            />
                        )}
                    />
                )}
                {type === "text-icon" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <IconTextFieldSmallStyled
                                {...field}
                                id={field.name}
                                error={error}
                                size="small"
                                fullWidth
                                margin="normal"
                                label={label}
                                autoComplete={autoComplete}
                                autoFocus={autoFocus}
                                type="text"
                                sx={sxExtra}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                sx={{visibility: value ? "visible" : "hidden"}}
                                                onClick={onClick}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                <FontAwesomeIcon style={{fontSize: "1rem", color: "#9D0000"}}
                                                                 icon={"xmark"}/>
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                className={className}
                            />
                        )}
                    />
                )}
                {type === "text-controlled" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <TextFieldStyled
                                {...field}
                                id={field.name}
                                error={error}
                                fullWidth
                                margin="normal"
                                label={label}
                                autoComplete={autoComplete}
                                autoFocus={autoFocus}
                                type="text"
                                onChange={(e) => {
                                    onChange(e);
                                    methods.clearErrors(name);
                                }}
                                value={value || ""}
                                className={className}
                            />
                        )}
                    />
                )}
                {type === "text-icon-controlled" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <IconTextFieldSmallStyled
                                {...field}
                                id={field.name}
                                error={error}
                                size="small"
                                fullWidth
                                margin="normal"
                                label={label}
                                autoComplete={autoComplete}
                                autoFocus={autoFocus}
                                type="text"
                                onChange={(e) => {
                                    onChange(e);
                                    methods.clearErrors(name);
                                }
                                }
                                value={value || ""}
                                // sx={{padding: "14px 14px 14px 23px"}}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                sx={{visibility: value ? "visible" : "hidden"}}
                                                onClick={onClick}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                <FontAwesomeIcon style={{fontSize: "1rem", color: "#9D0000"}}
                                                                 icon={"xmark"}/>
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                className={className}
                            />
                        )}
                    />
                )}
                {type === "autocomplete_api" && typeof optionsAPI !== "undefined" && (
                    <AutocompleteAPI
                        name={name}
                        defaultValue={defaultValue}
                        label={label}
                        optionsAPI={optionsAPI}
                        multiple={multiple}
                        filterOptions={filterOptions}
                        onChange={onChangeAutocomplete}
                        controlled={controlled}
                        value={valueAutocomplete}
                        error={error}
                    />
                )}
                {type === "autocomplete_field" && typeof optionsAPI !== "undefined" && (
                    <AutocompleteAPIField
                        name={name}
                        defaultValue={AutocompleteFieldDefaultValue}
                        label={label}
                        optionsAPI={optionsAPI}
                        multiple={multiple}
                        filterOptions={filterOptions}
                        onChange={onChangeAutocomplete}
                    />
                )}
                {type === "autocomplete" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <Autocomplete
                                {...field}
                                options={options}
                                blurOnSelect={true}
                                getOptionLabel={(option) => option.label}
                                PaperComponent={PaperStyled}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                renderOption={(props, option) => {
                                    return (
                                        <li {...props} key={option.value}>
                                            {option.label}
                                        </li>
                                    );
                                }}
                                renderInput={(params) => (
                                    <AutocompleteTextFieldStyled
                                        {...params}
                                        error={error}
                                        label={label}
                                        variant="filled"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                onChange={(_, data) => field.onChange(data)}
                                onInputChange={onInputChange}
                                multiple={multiple}
                                loading={loading}
                                limitTags={limitTags}
                            />
                        )}
                    />
                )}
                {type === "autocomplete-controlled" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <Autocomplete
                                {...field}
                                options={options}
                                blurOnSelect={true}
                                getOptionLabel={(option) => option.label}
                                PaperComponent={PaperStyled}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                renderOption={(props, option) => {
                                    return (
                                        <li {...props} key={option.value}>
                                            {option.label}
                                        </li>
                                    );
                                }}
                                renderInput={(params) => (
                                    <AutocompleteTextFieldStyled
                                        {...params}
                                        error={error}
                                        label={label}
                                        variant="filled"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                                onChange={onChange}
                                onInputChange={onInputChange}
                                filterOptions={filterOptions}
                                multiple={multiple}
                                disableClearable={disableClearable}
                                limitTags={limitTags}
                            />
                        )}
                    />
                )}
                {type === "controlled-select" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <TextFieldStyled
                                {...field}
                                disabled={disabled}
                                error={error}
                                InputLabelProps={{
                                    htmlFor: `${field.name}-select-input`,
                                }}
                                SelectProps={{
                                    inputProps: {
                                        id: `${field.name}-select-input`,
                                    },
                                    MenuProps: {
                                        PaperProps: {
                                            sx: {
                                                backgroundColor: "primary.light",
                                                borderRadius: "15px",
                                            },
                                        },
                                        BackdropProps: {
                                            invisible: true,
                                        }
                                    },
                                }}
                                fullWidth
                                select
                                margin="normal"
                                label={label}
                                autoFocus={autoFocus}
                                value={value}
                                className={className}
                                onChange={(e) => {
                                    onChange(e);
                                    methods.clearErrors(name);
                                }}
                            >
                                {options.map((option) => (
                                    option.subcategories ? (
                                        // <ListSubheader sx={{backgroundColor: "transparent", color: "text.disabled"}}>{option.label}</ListSubheader>
                                        option.subcategories.map((subcategory: any) => (
                                            <MenuItem key={subcategory.value} value={subcategory.value}>
                                                {subcategory.label}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                ))}
                            </TextFieldStyled>
                        )}
                    />
                )}
                {type === "controlled-select-small" && (
                    <>
                        <Controller
                            name={name}
                            control={methods.control}
                            defaultValue={defaultValue}
                            render={({field}) => (
                                <IconTextFieldSmallStyled
                                    {...field}
                                    disabled={disabled}
                                    size="small"
                                    InputLabelProps={{
                                        htmlFor: `${field.name}-select-input`,
                                    }}
                                    SelectProps={{
                                        inputProps: {
                                            id: `${field.name}-select-input`,
                                        },
                                        MenuProps: {
                                            PaperProps: {
                                                sx: {
                                                    backgroundColor: "primary.light",
                                                    borderRadius: "15px",
                                                },
                                            },
                                            BackdropProps: {
                                                invisible: true,
                                            }
                                        },
                                    }}
                                    fullWidth
                                    select
                                    margin="normal"
                                    label={label}
                                    autoFocus={autoFocus}
                                    value={value}
                                    className={className}
                                    onChange={onChange}
                                    InputProps={{
                                        endAdornment: (
                                            onClick ? (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        sx={{
                                                            visibility: value ? "visible" : "hidden",
                                                            marginLeft: "20px"
                                                        }}
                                                        onClick={onClick}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        <FontAwesomeIcon style={{fontSize: "1rem", color: "#9D0000"}}
                                                                         icon={"xmark"}/>
                                                    </IconButton>
                                                </InputAdornment>
                                            ) : (
                                                <></>
                                            )
                                        ),
                                    }}
                                >
                                    {options.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </IconTextFieldSmallStyled>
                            )}
                        />
                    </>
                )}
                {type === "select-small-bg-white" && (
                    <>
                        <Controller
                            name={name}
                            control={methods.control}
                            defaultValue={defaultValue}
                            render={({field}) => (
                                <IconTextFieldSmallStyled
                                    {...field}
                                    disabled={disabled}
                                    size="small"
                                    InputLabelProps={{
                                        htmlFor: `${field.name}-select-input`,
                                    }}
                                    SelectProps={{
                                        inputProps: {
                                            id: `${field.name}-select-input`,
                                        },
                                        MenuProps: {
                                            PaperProps: {
                                                sx: {
                                                    backgroundColor: "primary.light",
                                                    borderRadius: "15px",
                                                },
                                            },
                                            BackdropProps: {
                                                invisible: true,
                                            }
                                        },
                                    }}
                                    fullWidth
                                    select
                                    margin="normal"
                                    label={label}
                                    autoFocus={autoFocus}
                                    InputProps={{
                                        endAdornment: (
                                            onClick ? (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        sx={{
                                                            visibility: value ? "visible" : "hidden",
                                                            marginLeft: "20px"
                                                        }}
                                                        onClick={onClick}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        <FontAwesomeIcon style={{fontSize: "1rem", color: "#9D0000"}}
                                                                         icon={"xmark"}/>
                                                    </IconButton>
                                                </InputAdornment>
                                            ) : (
                                                <></>
                                            )

                                        ),
                                    }}
                                    className={className}
                                >
                                    {options.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </IconTextFieldSmallStyled>
                            )}
                        />
                    </>
                )}
                {type === "select" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <TextFieldStyled
                                {...field}
                                InputLabelProps={{
                                    htmlFor: `${field.name}-select-input`,
                                }}
                                SelectProps={{
                                    inputProps: {
                                        id: `${field.name}-select-input`,
                                    },
                                    MenuProps: {
                                        PaperProps: {
                                            sx: {
                                                backgroundColor: "primary.light",
                                                borderRadius: "15px",
                                            },
                                        },
                                        BackdropProps: {
                                            invisible: true,
                                        }
                                    },
                                }}
                                fullWidth
                                select
                                margin="normal"
                                label={label}
                                autoFocus={autoFocus}
                                error={error}
                                className={className}
                            >
                                {options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextFieldStyled>
                        )}
                    />
                )}
                {type === "select-small" && (
                    <Controller
                        name={name}
                        control={methods.control}
                        defaultValue={defaultValue}
                        render={({field}) => (
                            <IconTextFieldBgStyled
                                {...field}
                                InputLabelProps={{
                                    htmlFor: `${field.name}-select-input`,
                                }}
                                SelectProps={{
                                    inputProps: {
                                        id: `${field.name}-select-input`,
                                    },
                                    MenuProps: {
                                        PaperProps: {
                                            sx: {
                                                backgroundColor: "primary.light",
                                                borderRadius: "6px",
                                            },
                                        },
                                        BackdropProps: {
                                            invisible: true,
                                        }
                                    },
                                }}
                                fullWidth
                                select
                                margin="normal"
                                label={label}
                                autoFocus={autoFocus}
                                className={className}
                                error={error}
                            >
                                {options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </IconTextFieldBgStyled>
                        )}
                    />
                )}
                <ErrorsList show={errorMessage !== ""}>{errorMessage}</ErrorsList>
            </>
        </Box>
    );
};

export default FormField;